/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Languages_LabelInputs */



/**
* | output |
* | --- |
* | "Languages" |
*
* @param {Knp_Guide_Languages_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_languages_label = /** @type {((inputs?: Knp_Guide_Languages_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Languages_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langues")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprachen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingue")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Языки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idiomas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("言語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बोली")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Línguas")
	return /** @type {LocalizedString} */ ("Languages")
});